<div>
    <section>
        <app-nav (searchFor)="searching($event)" (reloadMainPostData)="reloadMainPostData($event)"></app-nav>
        <app-store [reload]="reload" [searchVal]="searchVal" [searchBool]="searchBool" [searchCat]="searchCat" (backFunk)="backing()"></app-store>
    </section>  
</div>